import ValueSWIcon from "../../assets/product-list-assets/gbe-1u.svg";
import type { ProductListGroup } from "../../types";

export const productListSwitchingValue: ProductListGroup = {
  id: "productListSwitchingValue",
  title: "productListGroup.switchingValue.title",
  icon: {
    src: ValueSWIcon,
    width: 24,
    height: 24,
  },
};
